const chips = ["明星八卦", "社会热点", "热瓜合集", "新剧新综", "网友辣评"];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20flat%20editorial%20illustration%20of%20a%20cheerful%20crowd%20gathering%20around%20a%20giant%20oversized%20watermelon%20at%20a%20lively%20town%20square%2C%20floating%20chat%20bubbles%20and%20sparkles%20and%20star%20icons%20rising%20above%2C%20warm%20coral%20red%20and%20cream%20and%20soft%20amber%20palette%2C%20playful%20modern%20vector%20art%20with%20bold%20geometric%20shapes%20and%20subtle%20grain%20texture%2C%20generous%20negative%20space%2C%20inviting%20warm%20cohesive%20scene%2C%20no%20text&width=1600&height=900&seq=hero-watermelon-00&orientation=landscape"
          alt="一群人在广场上围着一个大西瓜讨论新鲜热点话题的插画，象征吃瓜与热闹氛围"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/60"></div>
      </div>

      <div className="wrap relative flex min-h-[540px] flex-col items-center justify-center py-24 text-center md:min-h-[620px]">
        <span className="mb-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-80"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
          </span>
          今日份热瓜持续上新中
        </span>

        <h1 className="font-display text-4xl font-black leading-tight text-background-50 md:text-6xl">
          吃瓜五一
          <span className="mx-3 inline-block bg-gradient-to-r from-accent-300 to-primary-300 bg-clip-text text-transparent">
            ，一个入口管够
          </span>
        </h1>
        <p className="mt-5 max-w-2xl text-base font-light leading-relaxed text-background-100 md:text-lg">
          娱乐八卦、社会热点、新剧新综……每天都有新鲜爆料与热瓜合集在等你。刷话题、看真相、参与热评，
          <span className="font-bold text-background-50">想吃的瓜这里都有，且上新快、够热、不隔夜。</span>
        </p>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-2">
          {chips.map((c) => (
            <li key={c}>
              <span className="whitespace-nowrap rounded-full bg-background-50/15 px-3.5 py-1.5 text-sm text-background-50 backdrop-blur">
                #{c}
              </span>
            </li>
          ))}
        </ul>

        <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#feed"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-base font-bold text-background-50 transition hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-fire-fill mr-2 text-lg text-accent-300"></i>马上开吃
          </a>
          <a
            href="#trending"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-base font-bold text-background-50 backdrop-blur transition hover:bg-background-50/20 sm:w-auto"
          >
            看看今日热榜
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-4 border-t border-background-50/20 pt-6 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-accent-300 md:text-3xl">每日上百条</p>
            <p className="mt-1 text-xs text-background-200">热点筛选上新</p>
          </div>
          <div className="border-x border-background-50/20">
            <p className="font-display text-2xl font-bold text-accent-300 md:text-3xl">24h</p>
            <p className="mt-1 text-xs text-background-200">大热瓜实时跟进</p>
          </div>
          <div>
            <p className="font-display text-2xl font-bold text-accent-300 md:text-3xl">零广告打扰</p>
            <p className="mt-1 text-xs text-background-200">清爽阅读体验</p>
          </div>
        </div>
      </div>
    </section>
  );
}